import { Component, Input } from '@angular/core';

@Component({
  selector: 'condition-open',
  template: require('./condition-open.component.pug'),
  styles: [require('./condition-open.component.css').toString()],
})
export class ConditionOpenComponent {
  @Input()
  condition: any;
}
